<template>
  <section class="hero-banner" aria-label="Featured banners">
    <div
      v-if="currentBanner"
      ref="slide"
      class="hero-slide"
      :aria-label="currentBanner.title || $store.getters.t('featuredMotorcycle')"
      @click="openBanner"
      @touchstart.passive="handleTouchStart"
      @touchend.passive="handleTouchEnd"
    >
      <picture class="hero-slide__media">
        <source v-if="mobileImage" media="(max-width: 768px)" :srcset="mobileImage">
        <img
          ref="mediaImage"
          :src="desktopImage"
          :alt="currentBanner.title || $store.getters.t('featuredMotorcycle')"
          @load="syncNotePosition"
        >
      </picture>
      <div class="hero-overlay">
        <p v-if="currentBanner.title" class="hero-caption">{{ currentBanner.title }}</p>
      </div>
      <!-- 海报左下说明：贴在图片左下角，切换轮播图时不跟着换内容 -->
      <p v-if="caption" ref="note" class="hero-banner__note">{{ caption }}</p>
    </div>
    <div v-else class="hero-slide hero-slide--fallback">
      <div class="hero-empty">{{ $store.getters.t('noData') }}</div>
    </div>
    <div v-if="banners.length" class="hero-controls">
      <div class="hero-dots">
        <button
          v-for="(banner, index) in banners"
          :key="banner.id || index"
          type="button"
          :class="{ active: index === activeIndex }"
          :aria-label="`Banner ${index + 1}`"
          @click.stop="goTo(index)"
        ></button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroBanner',
  props: {
    banners: { type: Array, default: () => [] },
    // 后台「海报左下说明」：固定在横幅左下角，不随轮播切换
    caption: { type: String, default: '' }
  },
  data () { return { activeIndex: 0, timer: null, touchStartX: 0 } },
  computed: {
    currentBanner () { return this.banners[this.activeIndex] },
    desktopImage () { return this.currentBanner && this.currentBanner.imageUrl || '' },
    mobileImage () { return this.currentBanner && (this.currentBanner.mobileImageUrl || this.currentBanner.mobile_image_url) || '' }
  },
  watch: {
    banners () { this.activeIndex = 0; this.startTimer(); this.$nextTick(this.syncNotePosition) },
    caption () { this.$nextTick(this.syncNotePosition) },
    activeIndex () { this.$nextTick(this.syncNotePosition) }
  },
  mounted () {
    this.startTimer()
    this.syncNotePosition()
    window.addEventListener('resize', this.syncNotePosition)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    window.removeEventListener('resize', this.syncNotePosition)
  },
  methods: {
    // 海报左下说明：图片用 object-fit: contain 渲染，两侧/上下可能留白，
    // 这里按图片实际显示区域计算，把说明固定贴图片左下角
    syncNotePosition () {
      const note = this.$refs.note
      const img = this.$refs.mediaImage
      const slide = this.$refs.slide
      if (!note || !img || !slide) return
      const slideRect = slide.getBoundingClientRect()
      const imgRect = img.getBoundingClientRect()
      const nw = img.naturalWidth || 0
      const nh = img.naturalHeight || 0
      note.style.left = ''
      note.style.bottom = ''
      if (!nw || !nh || !imgRect.width || !imgRect.height) return
      const scale = Math.min(imgRect.width / nw, imgRect.height / nh)
      const contentWidth = nw * scale
      const contentHeight = nh * scale
      const contentLeft = imgRect.left + (imgRect.width - contentWidth) / 2
      const contentBottom = imgRect.top + (imgRect.height - contentHeight) / 2 + contentHeight
      // 贴图片左下角：约为图片宽 2.5% / 高 2.6% 的间距，小屏保底
      const insetLeft = Math.max(16, Math.round(contentWidth * 0.025))
      const insetBottom = Math.max(12, Math.round(contentHeight * 0.026))
      note.style.left = Math.round(contentLeft - slideRect.left + insetLeft) + 'px'
      note.style.bottom = Math.round(slideRect.bottom - contentBottom + insetBottom) + 'px'
    },
    startTimer () {
      clearInterval(this.timer)
      if (this.banners.length > 1) this.timer = setInterval(this.next, 3500)
    },
    next () { if (this.banners.length) this.activeIndex = (this.activeIndex + 1) % this.banners.length },
    previous () { if (this.banners.length) this.activeIndex = (this.activeIndex - 1 + this.banners.length) % this.banners.length },
    goTo (index) { this.activeIndex = index; this.startTimer() },
    handleTouchStart (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      this.touchStartX = touch ? touch.clientX : 0
    },
    handleTouchEnd (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch || !this.touchStartX) return
      const distance = touch.clientX - this.touchStartX
      this.touchStartX = 0
      if (Math.abs(distance) < 40) return
      if (distance < 0) this.next()
      else this.previous()
      this.startTimer()
    },
    openBanner () {
      const link = this.currentBanner && this.currentBanner.linkUrl
      if (!link) return
      if (link.startsWith('/')) this.$router.push(link)
      else window.open(link, '_blank', 'noopener')
    }
  }
}
</script>
